// extracted by mini-css-extract-plugin
export var button = "AdInterstitial-module__button___HxMgz";
export var close = "AdInterstitial-module__close___a8svp";
export var container = "AdInterstitial-module__container___X5Dio";